<template>
  <div>
    <vs-prompt
      title="Add alias to venue"
      @cancel="val = ''"
      @accept="accept"
      @close="close"
      :active.sync="prompt"
      accept-text="Add"
      :is-valid="validForm"
      class="todoPopup"
    >
      <vs-row>
        <vs-col vs-w="12">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Email</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <vs-input
                class="inputx w-full"
                placeholder="Search for venue to fill"
                v-model="newAlias"
              />
              <p v-if="newAlias">
                <br />{{ newAlias }} <strong>must</strong> be an alias of this
                venue's Google Group
              </p>
            </div>
          </div>
        </vs-col>
      </vs-row>
    </vs-prompt>
  </div>
</template>


<script>
import { mapGetters } from "vuex";
import validators from "@/views/mixins/validators";
export default {
  mixins: [validators],
  components: {},
  data() {
    return {
      newAlias: null,
      venueId: "",
      syncAccount: "",
      prompt: false,
    };
  },
  computed: {
    ...mapGetters({
      activeVenue: "venues/activeVenue",
      userVenues: "venues/venues",
    }),
    validForm() {
      return this.newAlias && this.validateEmail(this.newAlias);
    },
  },
  methods: {
    show(syncAccount, venueId) {
      this.newAlias = null;
      this.venueId = venueId;
      this.syncAccount = syncAccount;
      this.prompt = true;
    },
    async accept() {
      const dto = {
        alias: this.newAlias,
        venueId: this.venueId,
        syncEmail: this.syncAccount,
      };

      this.$vs.loading();

      await this.$store.dispatch("email/addSyncVenueAlias", dto);

      this.$vs.notify({
        color: "success",
        title: `Alias added`,
        text: "Alias added",
      });
      this.$vs.loading.close();
    },
    close() {},
  },
};
</script>

<style lang="scss" scoped>
</style>
